import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { APP_ROUTES } from '../../../shared/constants/routes';
import { map, catchError, of } from 'rxjs';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
    const authService = inject(AuthService);
    const router = inject(Router);

    if (!authService.isAuthenticated()) {
        return redirectToLogin(router, state.url);
    }

    if (authService.isRefreshTokenExpired()) {
        authService.logout();
        return redirectToLogin(router, state.url);
    }

    if (authService.isTokenExpired()) {
        return authService.refreshToken().pipe(
            map(() => true),
            catchError(() => {
                authService.logout();
                return of(redirectToLogin(router, state.url));
            }),
        );
    }

    return true;
};

function redirectToLogin(router: Router, returnUrl: string): boolean {
    router.navigate([APP_ROUTES.login], {
        queryParams: { returnUrl },
    });
    return false;
}
